// Libs
import React from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

// Components
import Search from '../../../components/Search';
import Feather from '../../../components/Feather';
import OrdersHistoryFilters from '../OrderHistoryFilters/OrdersHistoryFilters';
import MobileFilters from '../MobileFilters/MobileFilters';
import SideMenu from '../../SideMenu';

// Hooks
import useUI from '../../../hooks/useUI';
import useSearch from '../../../hooks/useSearch';
import useSideMenu from '../../../hooks/useSideMenu';

// Constants
import { ordersTabs } from '../../../constants/orderHistory';

// Styles
import { useStyles } from './OrderHistoryBarStyles';

const OrderHistoryBar = ({
  userType,
  activeTab = 0,
  filters,
  isRecurring = false,
}) => {
  const theme = useTheme();
  const { isTabletMode, isMobileMode } = useUI();
  const { active, toggleSideMenu, onCloseSideMenu } = useSideMenu();
  const { classes } = useStyles({ userType, isRecurring });
  const { onChange, onClearSearch } = useSearch();

  return (
    <>
      <Box className={classes.bar}>
        {isTabletMode && (
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}>
            <Typography className={classes.pageHeader}>
              Order History
            </Typography>
            {isTabletMode && !isMobileMode && (
              <Search
                onChange={onChange}
                onClearSearch={onClearSearch}></Search>
            )}
            {isMobileMode && (
              <Feather
                colorType="primary1"
                type="filters"
                onClick={toggleSideMenu(true)}
              />
            )}
          </Box>
        )}
        <Box className={classes.panel}>
          <Tabs
            value={activeTab}
            className={classes.tabs}
            TabIndicatorProps={{
              style: {
                backgroundColor:
                  userType === 'kite'
                    ? theme.palette.primary2
                    : theme.palette.primary1,
              },
            }}
            aria-label="secondary tabs example">
            {ordersTabs.map((tab) => (
              <Tab
                key={tab.path}
                className={classes.tab}
                label={tab.label}
                component={NavLink}
                to={tab.path}
              />
            ))}
          </Tabs>
          {!isTabletMode && (
            <Search
              className={classes.desktopSearch}
              onChange={onChange}
              onClearSearch={onClearSearch}></Search>
          )}
        </Box>
        {filters && !isMobileMode && (
          <OrdersHistoryFilters
            isRecurring={isRecurring}
            filters={filters}></OrdersHistoryFilters>
        )}
      </Box>
      <SideMenu
        title="Filters"
        styles={{
          width: '100%',
          maxWidth: 'initial',
          '& > div:nth-child(2)': {
            padding: '20px 12px',
          },
        }}
        active={active}
        toggleSideMenu={toggleSideMenu}>
        <MobileFilters
          isRecurring={isRecurring}
          filters={filters}
          onCloseSideMenu={onCloseSideMenu}
        />
      </SideMenu>
    </>
  );
};

export default OrderHistoryBar;
